import { chatMessengerShow } from "@origin-digital/event-dispatcher";
import {
  IInteractionData,
  interaction,
} from "@origin-digital/reporting-client";

export const showNativeMessenger = (): void => {
  chatMessengerShow({});
  interaction("click", {
    componentType: "button",
    id: "open-chat",
    parentContainer: "intercom",
    label: "open chat widget",
    isNative: true,
    eVar10: "Yes",
  } as IInteractionData);
};
